import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import adaptiveTest from "./data";
import { formatLongDate } from "./schedule";
import {
  cardDestination,
  ADAPTIVE_TEST_MARKER,
  ADAPTIVE_TEST_PROFILE_STATE,
} from "./navigation";

// Same keys Profile.js removes when a member logs out.
const MEMBER_SESSION_KEYS = ["MemberID", "MemberFname", "MemberLname", "MemberEmail", "MemberMobile", "userType"];

// Same icon as the Book Your Test cards in JoinUs.js.
const TestIcon = () => (
  <span className="uim-svg" style={{ display: "inline-block" }}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em">
      <rect width="20" height="15" x="2" y="3" className="uim-tertiary" rx="3"></rect>
      <path
        className="uim-primary"
        d="M16,21H8a.99992.99992,0,0,1-.832-1.55469l4-6a1.03785,1.03785,0,0,1,1.66406,0l4,6A.99992.99992,0,0,1,16,21Z"
      ></path>
    </svg>
  </span>
);

// One Adaptive Test slot (date + centre + slot) in Join Us → "Adaptive Test".
// Laid out like the Book Your Test cards in JoinUs.js, but the height grows with the content
// (the address is long) and every card in a row stretches to the same height.
// `entry` is one item from upcomingSlots(): { date, name, city, address, slot }.
const AdaptiveTestCard = ({ entry }) => {
  const navigate = useNavigate();
  const goToLogin = () => navigate("/Candidatelogin", { state: { fromPage: ADAPTIVE_TEST_MARKER } });

  const handleClick = (event) => {
    event.preventDefault();
    const { kind } = cardDestination(sessionStorage);
    if (kind === "profile") {
      navigate("/Profile", { state: ADAPTIVE_TEST_PROFILE_STATE });
    } else if (kind === "login") {
      goToLogin();
    } else {
      Swal.fire({
        icon: "info",
        title: adaptiveTest.title,
        text: "The Adaptive Test is for candidates. Members cannot take tests.",
        showCancelButton: true,
        confirmButtonText: "Log out",
      }).then((result) => {
        if (!result.isConfirmed) return;
        MEMBER_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
        goToLogin();
        // The header reads the login state only when drawn; reload like the site's own Log out does.
        // The browser keeps the navigation state (the return marker) across the reload.
        window.location.reload();
      });
    }
  };

  const venue = [entry.name, entry.address].filter(Boolean).join(", ");

  return (
    <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2 d-flex">
      <div className="card service-wrapper rounded border-0 shadow p-4 w-100" style={{ height: "auto", minHeight: "350px" }}>
        <div className="icon text-center text-custom h1 shadow rounded bg-white">
          <TestIcon />
        </div>
        <div className="content">
          <h5 className="title">{adaptiveTest.title}</h5>
          <br />
          <h1 className="startdate">{formatLongDate(entry.date)}</h1>
          <p className="text-muted mt-3 mb-0">
            <b>{adaptiveTest.description}</b>
            <br />
            <b>{entry.slot}</b>
            <br />
            <span>{venue}</span>
          </p>
          <div
            className="mt-3"
            style={{ border: "2px solid #e3e7e9", borderRadius: "4px", padding: "5px", cursor: "pointer" }}
          >
            <Link
              to="/Profile"
              state={ADAPTIVE_TEST_PROFILE_STATE}
              className="text-custom"
              onClick={handleClick}
            >
              Register <i className="mdi mdi-chevron-right"></i>
            </Link>
          </div>
          <div className="big-icon h1 text-custom">
            <TestIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdaptiveTestCard;
